class RequestAgentInterface {
    get = (url) => {
        throw new Error("get method not implemented")
    }

    post = (url, payload) => {
        throw new Error("get method not implemented")
    }
}

export default RequestAgentInterface;